module.exports = __webpack_public_path__ + "b1eb26d9802551da347ebff57b53ac5a.png";